import { render, staticRenderFns } from "./CommentToDishWindow.vue?vue&type=template&id=267c3400&scoped=true&"
import script from "./CommentToDishWindow.vue?vue&type=script&lang=js&"
export * from "./CommentToDishWindow.vue?vue&type=script&lang=js&"
import style0 from "./CommentToDishWindow.vue?vue&type=style&index=0&id=267c3400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c3400",
  null
  
)

export default component.exports